import { useQuery } from '@tanstack/react-query';

import FocusTimerApi from '~/apis/FocusTimerApi';
import { SearchFocusTimerDto } from '~/classes/dto/FocusTimerDto';

export const useGetFocusTimers = (searchFocusTimerDto: SearchFocusTimerDto) => {
  const query = useQuery({
    queryKey: ['focusTimers', searchFocusTimerDto],
    queryFn: () => FocusTimerApi.getFocusTimers(searchFocusTimerDto),
  });

  return query;
};

export const useGetItallFocusTimers = () => {
  const query = useQuery({
    queryKey: ['itallFocusTimers'],
    queryFn: () => FocusTimerApi.getItallFocusTimers(),
    refetchInterval: 30000,
  });

  return query;
};
